
import React from "react";
import { Breadcrumb, Button, Col, FloatButton, Input, Modal, Row, Spin, Typography, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { IoAddOutline, IoArrowBack, IoDownload, IoPencil, IoTrash } from "react-icons/io5";
import { PiFolderNotchOpenLight, PiFolderNotchLight, PiFileDocBold } from 'react-icons/pi'
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { POST_API, POST_CATCH, getToken, titleWeb } from "../../services/hello-api";

class MaterialList extends React.Component {

    state = {
        _navigate: false,
        _loading: true,
        _type: this.props.type === 'list' ? 'Lista' : 'Lixeira',
        _data: [],
        search: '',
        selected: ''
    }

    back = "/dashboard/proposta/material";

    componentDidMount = () => {
        titleWeb('Material')
        this.onRenderData()
    }
    
    // LOAD DATA
    onRenderData = () => {
        this.setState({_loading: true })
        setTimeout(async () => {
            POST_API('/material/search.php', { token: getToken(), search: this.state.search, type: 'list' }).then(rs => rs.json()).then(res => {
                if (res.return) {
                    this.setState({
                        _data: res.data
                    })
                } else {
                    message.error({ content: res.msg, key: 'screen' })
                }
            }).catch(() => POST_CATCH()).finally(() => this.setState({_loading: false }))
        }, 500);
    }

    onSeach = (v) => {

        this.setState({search: v.target.value})
        this.onRenderData()

    }

    onAction = (ID, type, title) => {
        var self = this
        Modal.confirm({
            title: title,
            icon: <ExclamationCircleOutlined />,
            cancelText: 'Não',
            okText: 'Sim',
            onOk() {
                POST_API('/material/del.php', { token: getToken(), ID: ID, type: type, selected: JSON.stringify(self.state.table_select) }).then(rs => rs.json()).then(res => {
                    if (res.return) {
                        message.success({ content: res.msg, key: 'screen' })
                        if (type === 'del-select' || type === 'rec-select') self.setState({table_select: []})
                        self.onRenderData()
                    } else {
                        message.warning({ content: res.msg, key: 'screen' })
                    }
                }).catch(() => {POST_CATCH()   }).finally(() => self.setState({_loading: false}))
            },
            onCancel() {},
        })
        
    }

    onSelect = (value) => {
        if (value === this.state.selected) {
            this.setState({selected: ''})
        } else {
            this.setState({selected: value})
        }
    }

    render = () => {

        const routes = [
            {title: <Typography className="page-bread">Proposta</Typography>},
            {title: <Typography className="page-bread">Material</Typography>},
            {title: <Typography className="page-bread active">{this.state._type}</Typography>},
        ]
        
        if (this.state._navigate) {
            return (<Navigate to={'/painel'} />)
        }

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                    { this.props.type === 'list' ? (
                        <>
                            <Link to="novo"><FloatButton className="float-button add2" icon={<IoAddOutline color="#FFF" size={25} />}/></Link>
                        </>
                    ) : (
                        <Link to={this.back}><FloatButton onClick={this.onChangePage} className="float-button back" icon={<IoArrowBack color="#FFF" size={25} />}/></Link>
                    )}
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={routes} />
                        </Col>
                        { this.props.type === 'list' ? (
                            <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                <Link to={'novo'}><Button type="primary" style={{marginRight: 5}} size="small" shape="round" className="sys-btn-primary sys-btn-small">Novo</Button></Link>
                                <Link to={'/dashboard/proposta'}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                            </Col>
                        ) : (
                            <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                                <Link to={this.back}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                            </Col>
                        ) }
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]} style={{marginBottom: 10}} align={'bottom'}>
                        <Col xs={24} md={24}>
                            <Input onChange={this.onSeach} placeholder="Pesquisar..." />
                        </Col>
                    </Row>
                    { this.state._loading ? <Row className="table__row_table" gutter={[8,8]} justify={'center'}><Spin /></Row> : (
                        <>
                            { this.state._data.length > 0 ?
                                <Row className="table__row_table" style={{marginBottom: 10}} align={'bottom'}>
                                    { this.state._data.map((v, i) => (
                                        <>
                                            { v.TYPE === 'P' ? 
                                            <>
                                                <Col key={i} span={24} className="material-item" onClick={() => this.onSelect(v.ID)}>
                                                    { this.state.selected === v.ID ? <PiFolderNotchOpenLight size={22} style={{marginRight: 10}} /> : <PiFolderNotchLight size={22} style={{marginRight: 10}} /> } <Typography className="material-text">{v.NAME}</Typography>
                                                    <Link to={v.ID} style={{position: 'absolute', right: 5}}><Button className="table__btn table__btn_edit" title='Editar' type="primary" shape="circle" size="small"><IoPencil size={14} /></Button></Link>
                                                    <Button style={{position: 'absolute', right: 35}} onClick={() => this.onAction(v.ID, 'del', 'Excluir registro?')} className="table__btn table__btn_delete" title='Excluir' type="primary" shape="circle" size="small"><IoTrash size={14} /></Button>
                                                </Col>
                                                <Col key={i+'a'} span={24} className={ this.state.selected === v.ID ? "material-items active" : "material-items"}>
                                                    <Row>
                                                    { v.ARQUIVOS.length > 0 ? (
                                                        <>
                                                            { v.ARQUIVOS.map((v2, i2) => (
                                                                <Col key={i2} span={24} className="material-item">
                                                                    <PiFileDocBold size={22} style={{marginRight: 10}} /> <Typography className="material-text">{v2.NAME}</Typography>
                                                                    <Link to={v2.ID} style={{position: 'absolute', right: 5}}><Button className="table__btn table__btn_edit" title='Editar' type="primary" shape="circle" size="small"><IoPencil size={14} /></Button></Link>
                                                                    <Button style={{position: 'absolute', right: 35}} onClick={() => this.onAction(v2.ID, 'del', 'Excluir registro?')} className="table__btn table__btn_delete" title='Excluir' type="primary" shape="circle" size="small"><IoTrash size={14} /></Button>
                                                                    <a href={v2.URL} target="_blank" rel="noreferrer" style={{position: 'absolute', right: 65}} className="ant-btn css-nnuwmp css-dev-only-do-not-override-nnuwmp ant-btn-circle ant-btn-primary ant-btn-sm table__btn table__btn_recover" title='Download' type="primary" shape="circle" size="small"><IoDownload size={14} /></a>
                                                                </Col>
                                                            )) }
                                                        </>
                                                    ) : <Col span={24} className="material-item">Nenhum arquivo encontrado</Col> }
                                                    </Row>
                                                </Col> 
                                            </>
                                            : null }
                                            { v.TYPE === 'F' ? 
                                                <Col key={i} span={24} className="material-item">
                                                    <PiFileDocBold size={22} style={{marginRight: 10}} /> <Typography className="material-text">{v.NAME}</Typography>
                                                    <Link to={v.ID} style={{position: 'absolute', right: 5}}><Button className="table__btn table__btn_edit" title='Editar' type="primary" shape="circle" size="small"><IoPencil size={14} /></Button></Link>
                                                    <Button style={{position: 'absolute', right: 35}} onClick={() => this.onAction(v.ID, 'del', 'Excluir registro?')} className="table__btn table__btn_delete" title='Excluir' type="primary" shape="circle" size="small"><IoTrash size={14} /></Button>
                                                    <a href={v.URL} target="_blank" rel="noreferrer" style={{position: 'absolute', right: 65}} className="ant-btn css-nnuwmp css-dev-only-do-not-override-nnuwmp ant-btn-circle ant-btn-primary ant-btn-sm table__btn table__btn_recover" title='Download' type="primary" shape="circle" size="small"><IoDownload size={14} /></a>
                                                </Col>
                                            : null }
                                        </>
                                    )) }
                                </Row> 
                            : <Row className="table__row_table" gutter={[8,8]} justify={'center'}><Typography>Nenhum arquivo encontrado</Typography></Row> }
                        </>
                    )}
                </Col>
                
            </Row>
        )

    }

}

export default MaterialList;